import { render, staticRenderFns } from "./com-url.vue?vue&type=template&id=26975bc4&scoped=true"
import script from "./com-url.vue?vue&type=script&lang=js"
export * from "./com-url.vue?vue&type=script&lang=js"
import style0 from "./com-url.vue?vue&type=style&index=0&id=26975bc4&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26975bc4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26975bc4')) {
      api.createRecord('26975bc4', component.options)
    } else {
      api.reload('26975bc4', component.options)
    }
    module.hot.accept("./com-url.vue?vue&type=template&id=26975bc4&scoped=true", function () {
      api.rerender('26975bc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modulestore/components/com-url.vue"
export default component.exports